/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { FormProvider, useForm, useFieldArray } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import BomTypeForm from '../../../Pages/SupplierSuggestion/Module/Bom/BomTypeForm';
import Loader from '../../Utility/Loader/Loader';
import { toasterMsg } from '../../Toaster/Toaster';
import {
  getCompositionComponent,
  getSupplierSuggestUnits,
  getComponentType,
  AddSuggestion,
  getPlacementOptions,
  getFinishedOptions,
  getAllBOMComponentOptions,
  getExistingSuggestion,
} from '../../../Pages/SupplierSuggestion/store/SupplierSuggestion.action';
import { fetchSupplier } from '../../../Pages/DevlopmentOrder/Bom/store/BOMConfig.action';

function BomSupplierCard({ show, onHide, selectedBomSupplier, devOrderId }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const history = useHistory();
  const { compositionComponent, units, placementOptions, finishedOptions, bomSubComponentOptions, BOMComponent } = useSelector(
    (state) => state.SupplierSuggestion || {},
  );

  const { userInfo } = useSelector((state) => state.UserDetails || {});
  const { customAttributeBomList } = useSelector((state) => state.SystemMastersDetails || {});
  const { tier1Suppliers } = useSelector((state) => state.SuppliersDetails || {});

  const compositionFromReducer = compositionComponent;
  const unitsFromReducer = units;

  const [supplierOptions, setSupplierOptions] = useState([]);

  useEffect(() => {
    if (tier1Suppliers?.length > 0 && userInfo) {
      const localSupplierList = tier1Suppliers?.filter((item) => item?.name === 'Locally Sourced');
      localSupplierList.push({
        name: `${userInfo?.firstName} ${userInfo?.lastName}`,
        _id: userInfo.userId,
      });
      setSupplierOptions(localSupplierList);
    }
  }, [tier1Suppliers, userInfo]);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    formState: { errors, isValid },
    setValue,
    clearErrors,
    trigger,
    watch,
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'bomForm',
  });

  const [loading, setLoading] = useState(false);
  const [fetchingExistingSuggestion, setFetchingExistingSuggestion] = useState(false);
  const [bomData, setBomData] = useState(null);
  const [selectedBomType, setSelectedBomType] = useState(null);
  const [componentType, setComponentType] = useState([]);
  const [defaultDynamicColumns, setDefaultDynamicColumns] = useState([]);
  const [submitBtnState, setSubmitBtnState] = useState(true);
  const [selectedType] = useState({ value: 'amendment', label: 'Amendment' });

  const populateForm = (data) => {
    const formData = {
      componentCode: data?.referenceCode || '',
      component_des: data?.bomDescription || '',
      supplier: data?.BOMSupplier?.[0] || data?.BOMSupplier || null,
      size: data?.size || '',
      sizeUnitOfMeasure: data?.sizeUnitOfMeasure || null,
      weight: data?.weight || '',
      weightUnitOfMeasure: data?.weightUnitOfMeasure || null,
      quantity: data?.quantity || '',
      quantityUnitOfMeasure: data?.quantityUnitOfMeasure || null,
      newPlacement: data?.newPlacement || [],
      transport: data?.transport || null,
      quality: data?.quality || null,
      finished: data?.finished || null,
      bomComponentSubType: data?.bomComponentSubType || null,
      componentType: data?.bomSubType || null,
      composition: data?.composition || [
        {
          percentage: null,
          composition: null,
        },
      ],
      additionalInfo: data?.additionalInfo || '',
      dynamicColumn: data?.dynamicColumn || defaultDynamicColumns,
      subBomList: data?.subBomList || [],
      productImpact: data?.productImpact || null,
      productName: data?.productName || '',
      pricePerUnit: data?.pricePerUnit || '',
      pricePerUnitCurrency: data?.pricePerUnitCurrency || '',
    };

    replace([formData]);

    setSubmitBtnState(false);
  };

  useEffect(() => {
    const fectchSupplierDetails = async () => {
      await dispatch(fetchSupplier({ devOrderId, allDetails: true }));
    };

    if (devOrderId) {
      fectchSupplierDetails();
    }
  }, [devOrderId]);

  const getExistingSuggestionData = async () => {
    try {
      setFetchingExistingSuggestion(true);
      const params = {
        devOrderId,
        _id: selectedBomSupplier,
      };
      const result = await dispatch(getExistingSuggestion(params));
      if (result?.length > 0) {
        history.push({
          pathname: `/supplier-suggestion/edit/${result[0]._id}/bom`,
          state: {
            returnUrl: `/development-order/${devOrderId}/bom`,
          },
        });
      }
    } catch (error) {
      console.error('Error fetching existing suggestion:', error);
    } finally {
      setFetchingExistingSuggestion(false);
    }
  };

  useEffect(() => {
    if (BOMComponent?.length > 0 && show) {
      const bomItem = BOMComponent.find((item) => item?._id === selectedBomSupplier);
      if (!bomItem) {
        getExistingSuggestionData();
        return;
      }
      setBomData(bomItem);
      setSelectedBomType({ _id: bomItem?.bomType });
      setDefaultDynamicColumns(bomItem?.dynamicColumn);
      populateForm(bomItem);
    } else if (BOMComponent?.length === 0 && show) {
      getExistingSuggestionData();
    } else if (!show) {
      reset();
      setBomData(null);
      setSelectedBomType(null);
      setComponentType([]);
      setDefaultDynamicColumns([]);
      replace([]);
      setFetchingExistingSuggestion(false);
    }
  }, [BOMComponent, show]);

  useEffect(() => {
    const fetchComponentTypes = async () => {
      if (selectedBomType?._id && userInfo?.userId) {
        await Promise.all([
          dispatch(
            getCompositionComponent({
              isActive: 1,
              loggedInUserId: userInfo?.userId,
              bomTypeId: selectedBomType?._id,
            }),
          ),
          dispatch(
            getSupplierSuggestUnits({
              isActive: true,
              loggedInUserId: userInfo?.userId,
            }),
          ),
        ]);

        const data = await dispatch(
          getComponentType({
            bomTypeId: selectedBomType?._id,
          }),
        );
        setComponentType(data?.data || []);
      } else {
        setComponentType([]);
      }
    };

    if (show && selectedBomType?._id) {
      fetchComponentTypes();
    }
  }, [selectedBomType, show, dispatch, userInfo?.userId]);

  const disabledSubmitButton = (disabled) => {
    setSubmitBtnState(disabled);
  };

  const removeSelectedBomComponent = (item, index) => {
    remove(index);
    if (fields?.length === 1 && index === 0) {
      setSubmitBtnState(true);
    }
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      let isSubmitValid = true;
      let percentageExists = false;

      if (data?.bomForm) {
        data?.bomForm?.forEach((bomItem) => {
          const composition = bomItem?.composition || [];
          let totalPercentage = 0;

          composition.forEach((comp) => {
            const percentage = parseFloat(comp?.percentage);
            if (!Number.isNaN(percentage) && percentage > 0) {
              percentageExists = true;
              totalPercentage += percentage;
            }
          });

          if (percentageExists && Math.abs(totalPercentage - 100) > 0.001) {
            isSubmitValid = false;
          }
        });
      }

      if (!isSubmitValid) {
        toasterMsg(t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.TOTAL_PERCENTAGE_VALIDATION'), 'danger');
        setLoading(false);
        return;
      }

      const bomArray = data?.bomForm?.map((ele) => {
        return {
          devOrderId: bomData?.devOrderId?._id || bomData?.devOrderId,
          libId: bomData?.libId || null,
          bomLibId: bomData?._id || selectedBomSupplier,
          bomSubType: ele?.componentType?._id,
          referenceCode: ele?.componentCode,
          bomDescription: ele?.component_des,
          BOMSupplier: ele?.supplier?._id,
          size: ele?.size,
          sizeUnitOfMeasure: ele?.sizeUnitOfMeasure?._id,
          weight: ele?.weight,
          weightUnitOfMeasure: ele?.weightUnitOfMeasure?._id,
          quantity: ele?.quantity,
          quantityUnitOfMeasure: ele?.quantityUnitOfMeasure?._id,
          newPlacement: ele?.newPlacement?.map((item) => item?.value || item?._id) || [],
          bomComponentSubType: ele?.bomComponentSubType?._id || null,
          finished: ele?.finished?._id || null,
          transport: ele?.transport || null,
          quality: ele?.quality || null,
          composition: ele?.composition?.filter((compo) => {
            return compo?.percentage !== null || compo?.composition !== null;
          }),
          additionalInfo: ele?.additionalInfo,
          status: 'Pending',
          dynamicColumn: ele?.dynamicColumn || [],
          subBomList: ele?.subBomList || [],
          productImpact: ele?.productImpact || null,
          _id: bomData?._id || null,
          pricePerUnitCurrency: ele?.pricePerUnitCurrency?.value || ele?.pricePerUnitCurrency || '',
          pricePerUnit: ele?.pricePerUnit || '',
        };
      });
      const suggestionData = {
        supplierId: userInfo?.userId || userInfo?._id,
        devOrderIds: [bomData?.devOrderId?._id || bomData?.devOrderId],
        type: selectedType?.value,
        section: 'bom',
        bomType: bomData?.bomType,
        bomComponents: bomArray,
        comment: '',
      };

      const result = await dispatch(AddSuggestion(suggestionData, t));

      if (result) {
        toasterMsg(t('SUPPLIER_SUGGESTION.BACKEND_SERVICE.SUPPLIER_SUGGESTION_ADDED_SUCCESSFULLY'), 'success');
        onHide();
        reset();
        setBomData(null);
        setSelectedBomType(null);
        setComponentType([]);
        setDefaultDynamicColumns([]);
      }
    } catch (error) {
      toasterMsg(error?.message || t('ERROR_MESSAGES.FAILED_TO_SAVE'), 'danger');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <Modal show={show} onHide={onHide} className="common-custom-modal product-add-edit-modal">
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="bom-supplier-modal-title">
            <span>
              {loading || fetchingExistingSuggestion
                ? t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.EDIT_SUGGESTION')
                : t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ADD_SUGGESTION')}
            </span>
          </Modal.Title>
          <button
            type="button"
            onClick={onHide}
            className="icon-close cursor-pointer border-0 bg-transparent"
            aria-label={t('ACTIONS.CLOSE')}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onHide();
              }
            }}
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        {(loading || fetchingExistingSuggestion) && (
          <div className="text-center py-4">
            <Loader />
          </div>
        )}
        {!loading && !fetchingExistingSuggestion && bomData && selectedBomType && (
          <FormProvider
            {...{
              control,
              register,
              fields,
              isValid,
              trigger,
              watch,
              disabledSubmitButton,
              append,
              remove,
              getValues,
              errors,
              setValue,
              reset,
              clearErrors,
              suggestionEditMode: false,
            }}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <BomTypeForm
                selectedBomType={selectedBomType}
                componentType={componentType}
                compositionFromReducer={compositionFromReducer}
                unitsFromReducer={unitsFromReducer}
                selectedType={selectedType}
                removeSelectedBomComponent={removeSelectedBomComponent}
                placementOptions={placementOptions}
                finishedOptions={finishedOptions}
                getPlacementOptions={(params) => dispatch(getPlacementOptions(params))}
                getFinishedOptions={(params) => dispatch(getFinishedOptions(params))}
                bomSubComponentOptions={bomSubComponentOptions}
                getAllBOMComponentOptions={() => dispatch(getAllBOMComponentOptions())}
                customAttributeBomList={customAttributeBomList}
                defaultDynamicColumns={defaultDynamicColumns}
                supplierOptions={supplierOptions}
                fromLibrary
              />
              <div className="common-model-footer mt-4">
                <button type="submit" aria-label="save" className="btn p-0" disabled={submitBtnState}>
                  <i className="icon-Tick-1 f-24" />
                </button>
              </div>
            </form>
          </FormProvider>
        )}
        {!loading && !fetchingExistingSuggestion && !bomData && (
          <div className="text-center py-4">
            <p>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUGGESTION_IS_PENDING')}</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

BomSupplierCard.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  selectedBomSupplier: PropTypes.string,
};

BomSupplierCard.defaultProps = {
  selectedBomSupplier: null,
};

export default BomSupplierCard;
